<app-sidenav>
  <ng-template #sidenavContent>
    <app-pdf-reactor-header>
      <app-card title="{{ 'content.this-order' | translate }}">
        <app-consumer-credit-report-sidenav [consumerReport]="consumerReport" [consumerRequest]="consumerRequest"></app-consumer-credit-report-sidenav>
      </app-card>
    </app-pdf-reactor-header>
  </ng-template>
  <ng-template #mainContent>
    @if (consumerReport?.consumers?.length > 0) {
      <div class="pt-3 pb-3">
        @if (_appCard && _creditReport) {
          <app-pdf-button-bar
            newOrderUrl="/consumer-services"
            [css]="consumerReportCss"
          [documentRootElement]="[_appCard, _creditReport]"></app-pdf-button-bar>
        }
        <app-consumer-credit-report-content [consumerReport]="consumerReport"
          [consumerRequest]="consumerRequest"
        (creditReport)="creditReport = $event"></app-consumer-credit-report-content>
        @if (_appCard && _creditReport && isAnyHit(consumerReport.consumers)) {
          <app-pdf-button-bar
            newOrderUrl="/consumer-services"
            [css]="consumerReportCss"
          [documentRootElement]="[_appCard, _creditReport]"></app-pdf-button-bar>
        }
      </div>
    }
  </ng-template>
</app-sidenav>
